export default {
  primary_darken1: '#003B97',
  primary: '#094687',
  primary_lighten1: '#1C48A8',
  primary_lighten2: '#2A64C9',
  primary_lighten3: '#2B64C9',
  primary_lighten4: '#85A3C3',
  primary_lighten5: '#E3F2FD',
  primary_lighten6: '#01244A',
  primary_lighten7: '#022e5a',
  black: '#241C15',
  black_lighten1: '#202223',
  black_lighten2: '#BABFC3',
  black_lighten3: '#F6F6F7',
  black_lighten4: '#F7F9FB',
  black_lighten5: '#F2F2F2',
  black_lighten6: '#e5e7e9',

  white: '#FFFFFF',
  info: '#2C6ECB',
  anchor: '#2C6ECB',
  upgrade_button: '#2f70ee',
  error: '#FC4F58',
  error_unpublish: '#D72C0D',
  error_lighten1: '#f3a7ab',
  error_lighten2: '#FE9067',
  alert: '#E8D734',
  yellow: '#E8D70C',
  yellow_rating: '#FFC96B',
  empty_rating: '#E4E5E7',
  yellow_chip: '#FFEA8A',
  yellow_lighten1: '#FAF7D7',
  success: '#22BE44',
  review_card: '#6D7175',
  success_lighten1: '#CEEDD7',
  success_lighten2: '#CCDFFF',
  success_lighten3: '#D4F2DA',

  accent: '#21BFAA',
  accent_chip: '#AEE9D1',
  progress_bar: '#65C0D0',
  accent_lighten1: '#A4E8F2',
  accent_icon: '#5C5F62',
  alert_warning: '#a87e1f',
  alert_error: '#FC4F58',
  widget_bar_error: '#D82C0D',
  smart_lighten1: '#01244A',
  smart_lighten2: '#F5F5F5',
  row_green: '#AEE9D1',
  check_green: '#007F5F',
  amazon_text: '#98C6CD',
  amazon_text_icon: '#00A0AC',
  recommend_tooltip: '#616161',
  advanced_pill: '#E0F0FF',
  import_quota_pill: '#FFD6A4',
  migrate_error: '#FEE9E8',
  migrate_label: '#8E1F0B',
  toast_default: '#1A1A1A',
  toast_error: '#D82C0D',
  toast_success: '#22BE44',
  plans_bar: '#29845A',
  plans_background: '#FAFBFB',
};
